var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.rowData
      ? _c(
          "div",
          { staticClass: "asc__showPage-container" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "header",
                    [
                      _c("Breadcrumb", {
                        attrs: { title: _vm.rowData.Description1 }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c("section", [
                    _c("span", [
                      _c("i", { staticClass: "fas fa-check" }),
                      _vm._v(" "),
                      _c("b", [_vm._v(_vm._s(_vm.$t("get.status")) + ":")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.rowData.StatusId
                              ? _vm.$t("insert.active")
                              : _vm.$t("insert.passive")
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("i", { staticClass: "fas fa-code" }),
                      _vm._v(" "),
                      _c("b", [_vm._v(_vm._s(_vm.$t("get.code")) + ":")]),
                      _vm._v(" " + _vm._s(_vm.rowData.Code))
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("i", { staticClass: "fas fa-code" }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.$t("insert.contract.Description1")) + ":"
                        )
                      ]),
                      _vm._v(" " + _vm._s(_vm.rowData.Description1))
                    ])
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tabs",
              [
                _c(
                  "b-tab",
                  { attrs: { title: _vm.$t("get.detail"), active: "" } },
                  [
                    _c(
                      "b-row",
                      { staticClass: "p-4" },
                      [
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.LoadingDate,
                                    "date",
                                    "insert.loadingplan.LoadingDate"
                                  )
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Route,
                                    "object",
                                    "insert.loadingplan.Route"
                                  )
                                )
                              }
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "12" } },
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("h6", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.loadingplan.items"))
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.rowData.LoadingPlanItems &&
                                _vm.rowData.LoadingPlanItems.length > 0
                                  ? _c("NextExportDetail", {
                                      attrs: {
                                        url:
                                          "VisionNextStockManagement/api/LoadingPlan/ExcelExportItems",
                                        "record-id": _vm.rowData.RecordId,
                                        "record-key": "loadingPlanId",
                                        "file-name": _vm.$t(
                                          "insert.loadingplan.items"
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-table-simple",
                                  {
                                    attrs: {
                                      responsive: "",
                                      hover: "",
                                      small: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "b-thead",
                                      { attrs: { "head-variant": "light" } },
                                      [
                                        _c(
                                          "b-tr",
                                          [
                                            _c("b-th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "insert.loadingplan.items"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("b-th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "insert.loadingplan.itemCode"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("b-th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "insert.loadingplan.unit"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("b-th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "insert.loadingplan.PlanQuantity"
                                                  )
                                                )
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tbody",
                                      _vm._l(
                                        _vm.rowData.LoadingPlanItems,
                                        function(result, i) {
                                          return _c(
                                            "tr",
                                            { key: i },
                                            [
                                              _c("b-td", [
                                                _vm._v(
                                                  _vm._s(
                                                    result.Item
                                                      ? result.Item.Label
                                                      : ""
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("b-td", [
                                                _vm._v(
                                                  _vm._s(
                                                    result.Item
                                                      ? result.Item.Code
                                                      : ""
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("b-td", [
                                                _vm._v(
                                                  _vm._s(
                                                    result.Unit
                                                      ? result.Unit.Label
                                                      : ""
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("b-td", [
                                                _vm._v(
                                                  _vm._s(result.PlanQuantity)
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cfa3450", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cfa3450","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LoadingPlan/get.vue
// module id = null
// module chunks = 